import { captureException } from '@sentry/react'

import { useSettingsAndTranslations } from '@/hooks/use-settings-and-translations'
import {
  getKompisTranslationByKey,
  getTranslationByKey,
  type KompisTranslationKey,
  type SofaTranslationKey,
} from '@/i18n'

/**
 * Custom hook for handling translations and text direction.
 */
export function useTranslate() {
  const { dexfSettings, translations } = useSettingsAndTranslations()

  /**
   * @deprecated Use css instead to handle text direction.
   * Unless you know what you're doing.
   */
  const isRTL = dexfSettings.localisation.writeDirection === 'rtl'

  const { kompis, ...sofaTranslations } = translations

  function translateString(key: SofaTranslationKey) {
    try {
      return getTranslationByKey(key as SofaTranslationKey, sofaTranslations)
    } catch {
      captureException(new Error(`Translation key not found in sofa translations.`), {
        extra: { key },
      })
      return key
    }
  }

  function translateStringFromKompis(key: KompisTranslationKey) {
    try {
      return getKompisTranslationByKey(key as KompisTranslationKey, kompis)
    } catch {
      captureException(new Error(`Translation key not found in kompis translations.`), {
        extra: { key },
      })
      return key
    }
  }

  return { isRTL, translateString, translateStringFromKompis }
}
